module.exports = __webpack_public_path__ + "img/icon-nextshop-package.8d7ce746.png";